@if (label || withOutLabel) {
  <div
    class="tag status-{{ type }} h4-bold"
    [class.code-view]="codeView"
    [ngClass]="{ withIcon: withIcon }"
    [class.right-icon]="rightIcon"
    [class.clickable]="clickable"
    (click)="clickable ? click() : null">
    @if (IconType !== 'no_icon') {
      <span class="left-icon btn-icon">
        <app-ce-icon
          [name]="IconType"
          [svg_class]="['d-flex', 'badge-icon']"
          role="img"
          aria-label="Status"></app-ce-icon>
      </span>
    }
    <span
      [class.d-none]="onlyIcon"
      class="d-flex align-items-center spacing-4"
      [title]="label"
      [class.no-ellipsis]="dividedText"
      [class.text-lowercase]="lowerCase"
      [class.text-uppercase]="uppercase"
      [ngClass]="{ 'text-ellipsis': ellipsis }">
      @if (dividedText) {
        <span class="h4-reg divide-text">{{ divideText }}</span>
      }
      {{ label | sentenceCase }}</span
    >
    @if (counter) {
      <app-counter [count]="count" [size]="'large'"></app-counter>
    }
    @if (IconType !== 'no_icon' && rightIcon) {
      <span class="right-icon btn-icon">
        <app-ce-icon
          [name]="IconType"
          [svg_class]="['d-flex', 'badge-icon']"
          role="img"
          aria-label="Status"></app-ce-icon>
      </span>
    }
    @if (close) {
      <app-ce-icon
        [name]="IconType"
        [svg_class]="['d-flex', 'cursor-pointer', 'badge-icon', 'primary-50']"
        role="img"
        aria-label="Status"></app-ce-icon>
    }
  </div>
}
